import { CCValidationState } from "../store/ccValidationReducer";

export const SET_CC_VALIDATION = "SET_CC_VALIDATION";
export const SET_CC_VREFOPTION = "SET_CC_VREFOPTION";
export const SET_CC_ABSOLUTE = "SET_CC_ABSOLUTE";
export const SET_CC_RELATIVE = "SET_CC_RELATIVE";
export const SET_CC_REDISPATCHING = "SET_CC_REDISPATCHING";
export const SET_CC_RETURNED_BRANCHES = "SET_CC_RETURNED_BRANCHES";
export const SET_CC_SENSITIVITY_THRESHOLD = "SET_CC_SENSITIVITY_THRESHOLD";
export const SET_CC_VALIDATION_THRESHOLD = "SET_CC_VALIDATION_THRESHOLD";
export const SET_CC_IVA_TRESHOLD = "SET_CC_IVA_TRESHOLD";
export const SET_CC_USE_MIN_RAM_FOR_IVA = "SET_CC_USE_MIN_RAM_FOR_IVA";
export const SET_CC_IVA_MIN_RAM_PERCENTAGE = "SET_CC_IVA_MIN_RAM_PERCENTAGE";
export const SET_IVA_SELECTION = "SET_IVA_SELECTION";
export const SET_IVA_EQUATION = "SET_IVA_EQUATION";
export const SET_MNECS_FOR_OPTIMIZATION = "SET_MNECS_FOR_OPTIMIZATION";
export const SET_TOGGLE_LOOP_FLOW = "SET_TOGGLE_LOOP_FLOW";
export const SET_LOOP_FLOW_THRESHOLD = "SET_LOOP_FLOW_THRESHOLD";
export const SET_MANUAL_PSTS = "SET_MANUAL_PSTS";
export const SET_MANUAL_TOPO_RAS = "SET_MANUAL_TOPO_RAS";
export const SET_RANGE_FROM_INITIAL = "SET_RANGE_FROM_INITIAL";
export const SET_DEFAULT_UPWARDS = "SET_DEFAULT_UPWARDS";
export const SET_DEFAULT_DOWNWARDS = "SET_DEFAULT_DOWNWARDS";
export const SET_RCDC_FIX = "SET_RCDC_FIX";
export const SET_MAX_RDR_UP = "SET_MAX_RDR_UP";
export const SET_MAX_RDR_DOWN = "SET_MAX_RDR_DOWN";
export const SET_ALL_RD_SWITCHABLE = "SET_ALL_RD_SWITCHABLE";
export const SET_SCALE_BY_LOAD = "SET_SCALE_BY_LOAD";
export const SET_WEIGH_DISTANCE = "SET_WEIGH_DISTANCE";

export const SetCCValidation = (state: CCValidationState) => {
    return { type: SET_CC_VALIDATION, state };
};
export const SetCCVRefOption = (value: number) => {
    return { type: SET_CC_VREFOPTION, value };
};
export const SetCCAbsolute = (value: number) => {
    return { type: SET_CC_ABSOLUTE, value };
};
export const SetCCRelative = (value: number) => {
    return { type: SET_CC_RELATIVE, value };
};
export const SetCCRedispatching = (opt: boolean) => {
    return { type: SET_CC_REDISPATCHING, opt };
};
export const SetCCReturnedBranches = (opt: boolean) => {
    return { type: SET_CC_RETURNED_BRANCHES, opt };
};
export const SetCCSensitivityThreshold = (value: number) => {
    return { type: SET_CC_SENSITIVITY_THRESHOLD, value };
};
export const SetCCValidationThreshold = (value: number) => {
    return { type: SET_CC_VALIDATION_THRESHOLD, value };
};
export const SetCCIvaThreshold = (value: number) => {
    return { type: SET_CC_IVA_TRESHOLD, value };
};
export const SetCCUseMinRamForIva = (value: boolean) => {
    return { type: SET_CC_USE_MIN_RAM_FOR_IVA, value };
};
export const SetCCIvaMinRamPercentage = (value: number) => {
    return { type: SET_CC_IVA_MIN_RAM_PERCENTAGE, value };
};
export const SetIvaSelection = (selection: number) => {
    return { type: SET_IVA_SELECTION, selection };
};
export const SetIvaEquation = (selection: number) => {
    return { type: SET_IVA_EQUATION, selection };
};
export const SetMNECsForOptimization = (opt: boolean) => {
    return { type: SET_MNECS_FOR_OPTIMIZATION, opt };
};
export const SetToggleLoopFlow = (opt: boolean) => {
    return { type: SET_TOGGLE_LOOP_FLOW, opt };
};
export const SetLoopFlowThreshold = (value: number) => {
    return { type: SET_LOOP_FLOW_THRESHOLD, value };
};
export const SetManualPSTs = (opt: boolean) => {
    return { type: SET_MANUAL_PSTS, opt };
};
export const SetManualTopoRAs = (opt: boolean) => {
    return { type: SET_MANUAL_TOPO_RAS, opt };
};
export const SetRangeFromInitial = (opt: boolean) => {
    return { type: SET_RANGE_FROM_INITIAL, opt };
};
export const SetDefaultUpwards = (opt: boolean) => {
    return { type: SET_DEFAULT_UPWARDS, opt };
};
export const SetDefaultDownwards = (opt: boolean) => {
    return { type: SET_DEFAULT_DOWNWARDS, opt };
};
export const SetRcdcFix = (opt: boolean) => {
    return { type: SET_RCDC_FIX, opt };
};
export const SetMaxRdrUp = (value: number) => {
    return { type: SET_MAX_RDR_UP, value };
};
export const SetMaxRdrDown = (value: number) => {
    return { type: SET_MAX_RDR_DOWN, value };
};
export const SetAllRdSwitchable = (opt: boolean) => {
    return { type: SET_ALL_RD_SWITCHABLE, opt };
};
export const SetScaleByLoad = (selection: boolean) => {
    return { type: SET_SCALE_BY_LOAD, selection };
};
export const SetWeightDistance = (selection: boolean) => {
    return { type: SET_WEIGH_DISTANCE, selection };
};
